import defaultState from './state';

const SET_CAME_FROM_ROUTE = (state, routeName) => {
  state.cameFromRouteName = routeName;
};

export default {
  SET_CAME_FROM_ROUTE
};



// WEBPACK FOOTER //
// ./src/store/modules/exercises/mutations.js